var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmall1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000829697 17.9985C4.90921 17.9985 8.88824 14.0195 8.88824 9.11112H0.000829697V17.9985Z",
    fill: "#3498DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88824 9.11154C8.88824 4.20315 12.8673 0.224121 17.7757 0.224121L17.7757 9.11154L8.88824 9.11154Z",
    fill: "#3498DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88741 9.11182C3.97903 9.11182 6.95716e-07 5.13279 1.55392e-06 0.224401L8.88742 0.224403L8.88741 9.11182Z",
    fill: "#3498DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7732 17.9992C17.7732 13.0908 13.7942 9.11182 8.88578 9.11182L8.88578 17.9992L17.7732 17.9992Z",
    fill: "#3498DB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmall1);
export default __webpack_public_path__ + "static/media/small-1.c08a8057ac506466847de8622bab94e2.svg";
export { ForwardRef as ReactComponent };